<template>
  <v-app>
    <div class="full-screen-background">
    <v-toolbar color="transparent" dark class="justify-center">
      <v-toolbar-title class="text-center" style="font-size: 200%">
        {{ $t('acquire.title') }}
      </v-toolbar-title>
    </v-toolbar>

    <v-main>
      <v-container class="py-4">
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model.number="amountReal"
              :label="$t('acquire.labelValueReal')"
              type="number"
              min="0"
              step="0.01"
              outlined
            />

            <div class="text-center mt-2">
              {{ $t('acquire.receive') }}
              <strong>{{ computedCoins }} {{ $t('acquire.coins') }}</strong>
            </div>

            <div class="text-center mb-4">
              {{ $t('acquire.approxUSD', { usd: computedUSD }) }}
            </div>

            <v-btn
              block
              color="#5c3e62"
              dark
              class="mt-2"
              :loading="loading"
              @click="buy"
            >
              {{ $t('acquire.sendOrderButton') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    </div>
  </v-app>
</template>

<script>
import { defineComponent } from 'vue'
import { notifyDiscord } from '@/services/api.js'

export default defineComponent({
  name: 'AcquireZephyrPoints',
  data: () => ({
    amountReal: 0,
    loading:    false,
    usdRate:    5.68290
  }),
  computed: {
    computedCoins() {
      return Math.round(this.amountReal * 100)
    },
    computedUSD() {
      if (this.amountReal <= 0) return '0.00'
      return (this.amountReal / this.usdRate).toFixed(2)
    }
  },
  methods: {
    async buy() {
      if (this.amountReal <= 0) {
        return alert(this.$t('acquire.alertValueGreaterZero'))
      }

      const token = localStorage.getItem('jwt_token')
      if (!token) {
        return alert(this.$t('acquire.alertLogin'))
      }

      this.loading = true
      try {
        await notifyDiscord(this.amountReal, token)
        alert(
          this.$t('acquire.alertSuccess', {
            coins: this.computedCoins,
            usd:   this.computedUSD
          })
        )
        this.amountReal = 0
      } catch (err) {
        console.error('Falha ao notificar Discord:', err)
        alert(this.$t('acquire.alertError'))
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    document.title = 'Grand Fantasia Zephyr'
  }
})
</script>

<style scoped>
.listOpacity{
  /* uma sobreposição branca meio translúcida */
  background-color: rgba(0, 0, 0, 0.459);
  padding: 1rem;          /* opcional, para dar espaçamento interno */
  border-radius: 0.5rem;  /* opcional, só pra ficar mais bonito */
}
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
</style>
